import { useEffect, useState } from "react";
import { useGovernment } from "contexts/GovernmentContext";
import PropTypes from "prop-types";
import React from "react";
import { Button, Container, Form, Modal } from "react-bootstrap";
import { Label } from "reactstrap";
import { BUTTON_LABELS } from "../../lang/ja";
import "./FAQRegisterDialog.css";

const propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  faq: PropTypes.object,
  onRegister: PropTypes.func,
  editable: PropTypes.bool,
};
const defaultProps = {
  isOpen: false,
  onClose: () => {},
  faq: null,
  onRegister: () => {},
  editable: true,
};

const FAQRegisterDialog = (props) => {
  const { isOpen, onClose, faq, onRegister, editable } = props;
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [url, setUrl] = useState("");
  const [fixTag, setFixTag] = useState("");
  const { government } = useGovernment();

  useEffect(() => {
    setQuestion(faq?.name);
    setAnswer(faq?.answer);
    setUrl(faq?.url);
  }, [faq]);

  if (!isOpen) return null;
  return (
    <div className="modal show" style={{ display: "block", position: "absolute" }}>
      <Modal.Dialog className="p-0">
        <Modal.Header closeButton onHide={onClose}>
          <Modal.Title className="">{!faq.governmentId ? BUTTON_LABELS.BUTTON_REGISTER_NEW : "編集"}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: "256px",
            overflow: "auto",
          }}
        >
          <Container
            style={{
              paddingBottom: "8px",
            }}
            className="d-flex align-items-center"
          >
            <Label className="w-25 m-0">質問</Label>
            <Form.Control
              className="w-75"
              as="textarea"
              rows={3}
              value={question}
              disabled={!!faq.srcMsgKey}
              onChange={(e) => {
                setQuestion(e.target.value);
              }}
            />
          </Container>
          {faq.aiAnswer && (
            <Container
              className="d-flex align-items-center"
              style={{
                paddingBottom: "8px",
              }}
            >
              <Label className="w-25 m-0">AI回答</Label>
              <Form.Control className="w-75" as="textarea" rows={3} value={faq.aiAnswer} disabled={true} />
            </Container>
          )}
          <Container
            className="d-flex align-items-center"
            style={{
              paddingBottom: "8px",
            }}
          >
            <Label className="w-25 m-0">回答</Label>
            <Form.Control
              className="w-75"
              as="textarea"
              rows={3}
              value={answer}
              disabled={!editable}
              onChange={(e) => {
                setAnswer(e.target.value);
              }}
            />
          </Container>
          <Container
            className="d-flex align-items-center"
            style={{
              paddingBottom: "8px",
            }}
          >
            <Label className="w-25 m-0">URL</Label>
            <Form.Control
              className="w-75"
              as="textarea"
              rows={3}
              value={url}
              disabled={!editable}
              onChange={(e) => {
                setUrl(e.target.value);
              }}
            />
          </Container>
          <Container style={{ paddingBottom: "8px" }} className="d-flex align-items-start">
            <Form.Label className="w-25 m-0">
              タグ
              <p>
                <span
                  onClick={() => setFixTag("")}
                  style={{
                    color: "#dc3545",
                    cursor: "pointer",
                    textDecoration: "underline",
                    fontSize: "0.7rem",
                  }}
                >
                  (タグを外し、未分類にする場合はここをクリック)
                </span>
              </p>
            </Form.Label>
            <div className="w-75 d-flex flex-wrap gap-2">
              {(government?.departments ?? [])
                .filter((d) => !d.includes("#invisible"))
                .map((department) => {
                  const pos = department.indexOf("#");
                  const departmentName = pos >= 0 ? department.substring(0, pos) : department;
                  return (
                    <div key={departmentName} className="position-relative" style={{ minWidth: "fit-content" }}>
                      <Form.Check
                        type="radio"
                        id={`radio-${departmentName}`}
                        name="department-radio"
                        checked={fixTag === departmentName}
                        onChange={() => setFixTag(departmentName)}
                        className="d-none"
                      />
                      <label
                        htmlFor={`radio-${departmentName}`}
                        className="px-3 py-1 rounded-pill"
                        style={{
                          border: "1px solid #dee2e6",
                          backgroundColor: fixTag === departmentName ? "#007bff" : "#ffffff",
                          color: fixTag === departmentName ? "#ffffff" : "#6c757d",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          fontSize: "0.9rem",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {departmentName}
                      </label>
                    </div>
                  );
                })}
            </div>
          </Container>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-end">
          <Button className="btn-outline btn-wd mr-1" variant="default" onClick={onClose}>
            キャンセル
          </Button>
          <Button
            className="btn-outline btn-wd mr-1"
            variant="default"
            disabled={!editable}
            onClick={() => {
              onRegister(question, answer, url, fixTag);
            }}
          >
            登録
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </div>
  );
};

FAQRegisterDialog.propTypes = propTypes;
FAQRegisterDialog.defaultProps = defaultProps;

export default FAQRegisterDialog;
